module.exports = __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Regular.6f876d09.woff2";